<template>
    <div id="newGeolocation" class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="saveGeolocation">
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="location_code">{{ label.location_code }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="location_code" name="location_code" v-model="geolocations.location_code" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="location_name">{{ label.location_name }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="location_name" name="location_name" v-model="geolocations.location_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="location_longitude">{{ label.location_longitude }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="location_longitude" name="location_longitude" v-model="geolocations.location_longitude" >
                            </div>
                            <div class="col-sm-2" style="display: none">
                                <button type="button" class="btn btn-secondary" @click="getCurrentLocation">CAPTURE</button>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="location_latitude">{{ label.location_latitude }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="location_latitude" name="location_latitude" v-model="geolocations.location_latitude" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="radius_range">{{ label.radius_range }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="radius_range" name="radius_range" v-model="geolocations.radius_range" placeholder="Minimum radius 20 meters">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="enable">{{ label.enable }}</label>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="enable_options" id="enable_yes" value="1" v-model="geolocations.enable">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.enable_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="enable_options" id="enable_no" checked="checked" value="0" v-model="geolocations.enable">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.enable_no }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row text-center">
                            <div class="col-sm-11">
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/geolocation`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'NEW GEOFENCING',
          label: {
                location_code: 'LOCATION CODE',
                location_name: 'LOCATION NAME',
                location_longitude: 'LOCATION LONGITUTE',
                location_latitude: 'LOCATION LATITUTE',
                radius_range: 'RADIUS RANGE (METRE)',
                enable: 'ENABLE',
                enable_yes: 'YES',
                enable_no: 'NO',
            },
            geolocations: {
                location_code: null,
                location_name: null,
                location_longitude: null,
                location_latitude: null,
                radius_range: null,
                enable: 1,
            },
            companies: [],
            validationMsg: '',
            status: '',

        }
    },

    methods: {
        saveGeolocation() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/geolocation'
            axios.post(this.$store.getters.rootAPI +'/geolocation/create', {
                location_code: vm.geolocations.location_code,
                location_name: vm.geolocations.location_name,  
                location_longitude: vm.geolocations.location_longitude,
                location_latitude: vm.geolocations.location_latitude,
                radius_range: vm.geolocations.radius_range,
                enable: vm.geolocations.enable,
            })
            .then(function (response) {
                vm.status = response.data.status
                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },

        getCurrentLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.geolocations.location_longitude = position.coords.longitude;
                this.geolocations.location_latitude = position.coords.latitude;
            }, error => {
                alert('Unable to obtain your location.');
            });
        } else {
            alert('This browser does not support capture your location');
        }
    }

    },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/geolocation/NewGeolocation.vue